/* EXPORT ENTITY TYPES */
export * from './kpi-statistic/kpi-statistic'
export * from './kpi/kpi'
export * from './kpi/kpi-type'
export * from './kpi-value/kpi-value'
export * from './kpi-value/kpi-value-type'
export * from './kpi-metric/kpi-metric'
export * from './kpi-metric/kpi-metric-type'
export * from './kpi-metric-value/kpi-metric-value'
export * from './kpi-metric-value/kpi-metric-value-type'
export * from './kpi-scope/kpi-scope'
export * from './kpi-org-scope/kpi-org-scope'

/* IMPORT ENTITIES AND RESOLVERS */
import {
  entities as KpiStatisticEntities,
  resolvers as KpiStatisticResolvers,
  subscribers as KpiStatisticSubscribers
} from './kpi-statistic'
import { entities as KpiEntities, resolvers as KpiResolvers } from './kpi'
import { entities as KpiValueEntities, resolvers as KpiValueResolvers } from './kpi-value'
import { entities as KpiMetricEntities, resolvers as KpiMetricResolvers } from './kpi-metric'
import { entities as KpiMetricValueEntities, resolvers as KpiMetricValueResolvers } from './kpi-metric-value'
import { entities as KpiOrgScopeEntities, resolvers as KpiOrgScopeResolvers } from './kpi-org-scope'
import { resolvers as KpiAlertResolvers } from './kpi-alert'
import { entities as KpiScopeEntities, resolvers as KpiScopeResolvers } from './kpi-scope'

export const entities = [
  /* ENTITIES */
  ...KpiStatisticEntities,
  ...KpiEntities,
  ...KpiValueEntities,
  ...KpiMetricEntities,
  ...KpiMetricValueEntities,
  ...KpiOrgScopeEntities,
  ...KpiScopeEntities
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    ...KpiStatisticResolvers,
    ...KpiResolvers,
    ...KpiValueResolvers,
    ...KpiMetricResolvers,
    ...KpiMetricValueResolvers,
    ...KpiOrgScopeResolvers,
    ...KpiAlertResolvers,
    ...KpiScopeResolvers
  ]
}
